import React from 'react';
import 'react-photo-view/dist/react-photo-view.css';
import AppRoutes from './routes/routes';


import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();
function App() {

  return (
    <>
      <QueryClientProvider client={queryClient}>
        <AppRoutes />
      </QueryClientProvider>


    </>

  );
}

export default App;